import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Select from "react-select";

import ActivityLog from '../ActivityLog';
import * as Common from '../Common';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import $ from "jquery";
import AsyncSelect from 'react-select/async';



import * as Picklist from "../Picklist";

function Master_executive() {
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [executiveData, setExecutiveData] = useState([]);
    const [userRight, setUserRight] = useState([]);

    const [srNo, setSrNo] = useState(0);
    const [employee, setEmployee] = useState("");
    const [designation, setDesignation] = useState({ value: 0, label: "Select" });
    const [address, setAddress] = useState("");
    const [country, setCountry] = useState({ value: 0, label: "Select" });
    const [state, setState] = useState({ value: 0, label: "Select" });
    const [city, setCity] = useState({ value: 0, label: "Select" });
    const [mobile, setMobile] = useState("");
    const [empcode, setEmpcode] = useState("");
    const [pan, setPan] = useState("");
    const [email, setEmail] = useState("");
    // Bank info states management
    const [bankcode, setbankcode] = useState('');
    const [bankname, setbankname] = useState('');
    const [accountno, setaccountno] = useState('');
    const [ifsccode, setifsccode] = useState('');
    const [status, setStatus] = useState(1);

    const [remark, setRemark] = useState("");

    const [countryData, setCountryData] = useState([]);

    const [cityData, setCityData] = useState([]);

    const [stateData, setStateData] = useState([]);

    const [designationData, setDesignationData] = useState([]);

    const [showAddNewBtn, setShowAddNewBtn] = useState(true);
    const [showFormBtn, setShowFormBtn] = useState(false);

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [formMode, setFormMode] = useState('Q'); // Q A E 
    const [msgTextYN, setMsgTextYN] = useState("");

    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [compareData, setCompareData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [designationFilter, setDesignationFilter] = useState({ value: 0, label: "Select" });
    const [employSearch, setEmploySearch] = useState('');
    const [ldgBankOptions, setLdgBankOptions] = useState([])


    // bank picklist management
    const [ldgAllBank, setLdgAllBank] = useState("indusland bank");
    const [visiblePg, setVisiblePg] = useState("");
    const [ldgAllBankCode, setLdgAllBankCode] = useState("");
    const [target, setTarget] = useState(0);





    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'EXECUTIVE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            $(".loader").show();
            setLoading(true);
            Common.callApi(Common.apiExecutive, [sid, 'getList'], (result) => {
                setLoading(false);
                let resp = JSON.parse(result);
                $(".loader").hide();
                if (resp.status) {
                    setExecutiveData(resp.data);
                } else {
                    setExecutiveData([]);
                }
            });
            Common.callApi(Common.apiDesignation, [sid, 'getSelect'], (result) => {
                let resp = JSON.parse(result);
                setDesignationData(resp);
            });
            Common.callApi(Common.apiCountry, [sid, 'getCnt'], function (result) {
                setCountryData(JSON.parse(result));
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const addNew = () => {
        setSrNo(0);
        // setActivityLog([]);
        setEmployee("");
        setDesignation({ value: 0, label: "Select" });
        setAddress("");
        setCountry({ value: 0, label: "Select" });
        setState({ value: 0, label: "Select" });
        setCity({ value: 0, label: "Select" });
        setMobile("");
        setEmpcode("");
        setPan("");
        setEmail("");
        setbankcode('');
        setaccountno('');
        setifsccode('');
        setbankname('');
        setStatus(1);
        setFormMode('A');
        setShowAddNewBtn(false);
        setShowFormBtn(true);
        setLdgAllBank('');
        setTarget(0);
    }

    const saveData = () => {
        if (employee === "") {
            setMsgText("Please fill Employee!");
            setMsgBox(true);
        } else if (formMode === 'E' && remark === '') {
            setMsgText('Please fill Remark!');
            setMsgBox(true);
        } else {
            var obj = {
                employee: employee,
                designation: designation.value,
                address: address,
                country: country.value,
                state: state.value,
                city: city.value,
                mobile: mobile,
                empcode: empcode,
                pan: pan,
                email: email,
                status: status,
                branch: 0,
                activitytype: srNo * 1 > 0 ? 'MODIFY' : 'CREATE',
                trancategory: 'M',
                trantype: 'MEXEC',
                trannumber: srNo,
                subtranno: 0,
                remark: remark,
                bankcode: bankcode,
                bankname: bankname,
                accountno: accountno,
                ifsccode: ifsccode,
                target: target,
            };
            const infoObject = Common.compareArrays(compareData, [obj]);

            if (userRight.edit === "1" && formMode === "E") {
                setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, 'MEXEC'));
            }
            $(".loader").show();
            Common.callApi(Common.apiExecutive, [sid, 'savelist', srNo, JSON.stringify(obj), JSON.stringify(tranAuditTrail)], (result) => {
                let resp = JSON.parse(result);
                if (resp.status) {
                    $(".loader").hide();
                    setShowFormBtn(false);
                    setShowAddNewBtn(true);
                    setRemark("");
                    setExecutiveData(resp.data);
                    setMsgText(resp.message);
                    setMsgBox(true);

                    setTranAuditTrail([]);
                } else {
                    setMsgText(resp.message);
                    setMsgBox(true);
                }
            });
        }
    }

    const cancelConfirm = () => {
        if (formMode === "A" || formMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setShowFormBtn(false);
        setShowAddNewBtn(true);
        setShowActivityLog(false);
    }

    // const cancelData = () => {
    //     setShowFormBtn(false);
    //     setShowAddNewBtn(true);
    // }
    const fillViewCompareObject = (resp) => {
        const obj2 = {
            employee: resp.employee,
            designation: resp.designation,
            address: resp.address,
            country: resp.country,
            state: resp.state,
            city: resp.city,
            mobile: resp.mobile,
            empcode: resp.empcode,
            pan: resp.pan,
            email: resp.email,
            status: resp.status,
            remark: remark,
            bankcode: resp.bankcode,
            bankname: resp.bankname,
            accountno: resp.acc_no,
            ifsccode: resp.ifsc_cd,
            target: resp.target
        };
        setCompareData([obj2]);
    }

    const fillEditForm = (id) => {
        setFormMode('Q');
        setShowActivityLog(false);
        Common.callApi(Common.apiExecutive, [sid, 'editList', id], (result) => {
            let resp = JSON.parse(result);
            fillViewCompareObject(resp);
            setTarget(resp.target ?? 0);
            setSrNo(resp.srno);
            setEmployee(resp.employee);
            setDesignation({ value: resp.designation, label: resp.md_desig });
            // setDesignation(resp.designation);
            // me_designation , md_designation
            setAddress(resp.address);
            setCountry({ value: resp.country, label: resp.cnt_nm });
            setState({ value: resp.state, label: resp.st_nm });
            setCity({ value: resp.city, label: resp.ct_nm });
            setMobile(resp.mobile);
            setPan(resp.pan);
            setEmail(resp.email);
            setLdgAllBank({
                id: `^${resp.bankcode}^${resp.bankname}`,
                label: `${resp.bankcode} ${resp.bankname}`
            })
            setbankcode(resp.bankcode)
            setbankname(resp.bankname);
            setaccountno(resp.acc_no);
            setifsccode(resp.ifsc_cd);
            setStatus(resp.status);
            setEmpcode(resp.empcode);
            setShowAddNewBtn(false);
            setShowFormBtn(true);
            console.log('res from backend for fill edit form: ', resp)
        });
    }

    const handleSetCountry = (v) => {
        setCountry(v);
        setState({ value: 0, label: "Select" });
        setCity({ value: 0, label: "Select" });
        Common.callApi(Common.apiState, [sid, 'getState', v.value], function (result) {
            setStateData(JSON.parse(result));
        });
    }

    const handleSetState = (v) => {
        setState(v);
        setCity({ value: 0, label: "Select" });
        Common.callApi(Common.apiCity, [sid, 'getCity', v.value], function (result) {
            setCityData(JSON.parse(result));
        });
    }

    const editData = () => {
        setFormMode('E');
    }

    const exportFile = () => {
        var obj = {
            right: 'EXECUTIVE',
            employName: employSearch,
            designation: designationFilter,
            target: target,
        }
        Common.callDownloadApiPost(Common.apiReport, "post", [sid, JSON.stringify(obj)]);
    }

    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "MEXEC", trannumber: srNo, trancategory: "M" });
    }


    const handelFilterList = (e) => {
        e.preventDefault();
        let filterData = {
            employName: employSearch,
            designation: designationFilter
        }
        Common.callApi(Common.apiExecutive, [sid, 'getList', JSON.stringify(filterData)], (result) => {
            setLoading(false);
            let resp = JSON.parse(result);
            $(".loader").hide();
            if (resp.status) {
                setExecutiveData(resp.data);
            }
            else {

                setExecutiveData([]);
            }
        });
    }

    const handleAllBankChange = (value) => {
        setbankcode(value.id.split('^')[1]);
        setbankname(value.id.split('^')[2]);
        setLdgAllBank(value);
        const allbank = value.id.split('^');
        setLdgAllBankCode(allbank[1]);
    };


    return (
        <>
            <LoginHeader />
            <Menu />

            <Container fluid>
                <Row>
                    <Col>
                        <h1> Executive </h1>
                    </Col>
                </Row>
                {
                    showAddNewBtn ?
                        <>
                            <Row >
                                <Col className='col-md-4 col-4'>
                                    <Form.Group >
                                        <Form.Label>Search <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type='text' placeholder='Search By Employ Name or GreytHR Code ' maxLength="100" value={employSearch}
                                            onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setEmploySearch)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-4 col-6'>
                                    <Form.Group>
                                        <Form.Label>Designation</Form.Label>
                                        <Select options={designationData} value={designationFilter} onChange={v => setDesignationFilter(v)} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: 40 }}>
                                <Col>
                                    {userRight.add === "1" ?
                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={addNew}>Add New</Button>
                                        : null
                                    }&nbsp;
                                    <Button variant='outline-primary' className='buttonStyle' type="button" size='sm' onClick={handelFilterList}  >List</Button>&nbsp;
                                    {
                                        userRight.query === "1" ?
                                            <>
                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={exportFile}>Export</Button>&nbsp;
                                            </>
                                            : null
                                    }
                                </Col>



                            </Row>
                        </>
                        : null
                }
                <Row><Col>&nbsp;</Col></Row>
                {
                    showFormBtn ?
                        <>
                            <Row>
                                <Col className="divContentCenter">
                                    <div className="maxFormWidth">
                                        <Form>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Serial Number</Form.Label>
                                                        <Form.Control type="text" placeholder="Serial Number" value={srNo}
                                                            disabled />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Employee<span className="mandatory text-danger">*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="Employee" maxLength={100}
                                                            value={employee}
                                                            onChange={(e) => Common.validateAlpValue(e.target.value, setEmployee)}
                                                            autoComplete="off"
                                                            disabled={formMode === 'Q'} />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Designation</Form.Label>
                                                        <Select options={designationData} value={designation} onChange={v => setDesignation(v)}
                                                            isDisabled={formMode === 'Q'}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Address</Form.Label>
                                                        <Form.Control type="text" placeholder="Address" maxLength={100}
                                                            value={address}
                                                            onChange={(e) => setAddress(e.target.value)}
                                                            autoComplete="off"
                                                            disabled={formMode === 'Q'}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Country</Form.Label>
                                                        <Select options={countryData} value={country} onChange={v => handleSetCountry(v)}
                                                            isDisabled={formMode === 'Q'}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>State</Form.Label>
                                                        <Select options={stateData} value={state} onChange={v => handleSetState(v)}
                                                            isDisabled={formMode === 'Q'} />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>City</Form.Label>
                                                        <Select options={cityData} value={city} onChange={v => setCity(v)}
                                                            isDisabled={formMode === 'Q'} />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Mobile</Form.Label>
                                                        <Form.Control type="text" placeholder="Mobile" maxLength={10}
                                                            value={mobile}
                                                            onChange={(e) => Common.validateNumValue(e.target.value, setMobile)}
                                                            autoComplete="off"
                                                            disabled={formMode === 'Q'}
                                                        />

                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>PAN</Form.Label>
                                                        <Form.Control type="text" placeholder="PAN" maxLength={100}
                                                            value={pan}
                                                            onChange={(e) => setPan(e.target.value)}
                                                            onBlur={(e) => Common.validatePan(e.target.value, setPan)}
                                                            autoComplete="off"
                                                            disabled={formMode === 'Q'}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>Employee GreytHR Code<span style={{ color: "red", fontWeight: "bold" }}>*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="Employee Code" maxLength={100}
                                                            value={empcode}
                                                            onChange={(e) => Common.validateNumValue(e.target.value, setEmpcode)}
                                                            autoComplete="off"
                                                            disabled={formMode === 'Q'}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>Email<span className="mandatory text-danger">*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="Email" maxLength={100}
                                                            value={email} onChange={(e) => setEmail(e.target.value)}
                                                            onBlur={(e) => Common.validtateEmail(e.target.value, setEmail)}
                                                            autoComplete="off"
                                                            disabled={formMode === 'Q'} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className="col-md-3 col-6">
                                                    <Form.Label>Bank Name<span className="mandatory text-danger">* </span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={ldgAllBank}
                                                        getOptionLabel={(e) => e.label}
                                                        getOptionValue={(e) => e.value}
                                                        loadOptions={Picklist.fetchAllBankPicklist}
                                                        onChange={handleAllBankChange}
                                                        placeholder="Select Bank"
                                                        isClearable
                                                        isDisabled={formMode === "Q" || visiblePg === "Q"}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>Account No<span className="mandatory text-danger">*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="Account No." maxLength={50} alt='Bank Account No'
                                                            onChange={(e) => Common.validateAlpNumValue(e.target.value, setaccountno)}
                                                            disabled={formMode === 'Q'}
                                                            value={accountno}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>IFSC Code<span className="mandatory text-danger">*</span></Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Bank IFSC Code"
                                                            onChange={(event) => Common.validateIFSC(event.target.value, setifsccode)}
                                                            value={ifsccode}
                                                            maxLength={11}
                                                            disabled={formMode === 'Q'}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>Status</Form.Label>
                                                        <Form.Select value={status} onChange={e => setStatus(e.target.value)} disabled={formMode === 'Q'} required>
                                                            <option value="1">ACTIVE</option>
                                                            <option value="0">INACTIVE</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group>
                                                        <Form.Label>Target</Form.Label>
                                                        <Form.Control type="text" placeholder="Target" maxLength={10} alt='Target'
                                                            onChange={(e) => Common.validateNumValue(e.target.value, setTarget)}
                                                            disabled={formMode === 'Q'}
                                                            value={target}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>&nbsp;</Col>
                                            </Row>
                                            {
                                                formMode === 'E' ?
                                                    <>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group>
                                                                    <Form.Label>Remark<span className="mandatory text-danger">*</span></Form.Label>
                                                                    <Form.Control type="text" placeholder="Remark" maxLength={50}
                                                                        value={remark}
                                                                        onChange={(e) => Common.validateAlpValue(e.target.value, setRemark)}
                                                                        autoComplete="off"
                                                                        required />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col>&nbsp;</Col>
                                                            <Col>&nbsp;</Col>
                                                            <Col>&nbsp;</Col>
                                                        </Row>
                                                    </> :
                                                    null
                                            }
                                            <Row><Col>&nbsp;</Col></Row>
                                            <Row>
                                                <Col>
                                                    {/* <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                        saveData()}>Save</Button>&nbsp;
                                                    <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() =>
                                                        cancelData()}>Cancel</Button> */}

                                                    <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() =>
                                                        cancelConfirm()}>Back</Button>&nbsp;&nbsp;

                                                    {
                                                        (userRight.edit === "1" && formMode === 'Q') ? <>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                editData()}>Edit</Button>&nbsp;
                                                        </> : null
                                                    }
                                                    {
                                                        (userRight.edit === "1" && formMode === 'E') || (userRight.add === "1" && formMode === 'A') ? <>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                saveData()}>Save</Button>&nbsp;
                                                        </> : null
                                                    }
                                                    {
                                                        (userRight.query === "1" && (formMode === 'E' || formMode === 'Q')) ? <>
                                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                btnActivityLog()}>Activity Log</Button>&nbsp;
                                                        </> : null
                                                    }
                                                </Col>
                                            </Row>
                                            <Row><Col>&nbsp;</Col></Row>
                                        </Form>
                                    </div>
                                </Col>
                            </Row>
                            {/* <Row>
                                {
                                    showActivityLog &&
                                    <>
                                        <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
                                    </>
                                }
                            </Row> */}
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Table responsive striped bordered hover>
                                        <thead>
                                            <tr>
                                                {userRight.edit === "1" ? <th></th> : null}
                                                <th className="textRight">Sr No</th>
                                                <th>Employee</th>
                                                <th>Designation</th>
                                                <th>Address</th>
                                                <th>Country</th>
                                                <th>State</th>
                                                <th>City</th>
                                                <th>Mobile</th>
                                                <th>Pan</th>
                                                <th>Employee GreytHR Code</th>
                                                <th>Email</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {

                                                loading ? (
                                                    null

                                                ) : executiveData.length > 0 ? (executiveData.map((res) => (
                                                    <tr key={res.me_srno}>
                                                        {userRight.edit === "1" ?
                                                            <td className="textCenter" >
                                                                <span className="handCursor" onClick={() => fillEditForm(res.me_srno)} >
                                                                    <div className="colorThemeBlue"><FontAwesomeIcon icon={faEye} /></div>
                                                                </span>
                                                            </td>
                                                            : null
                                                        }
                                                        <td className="textRight">{res.me_srno}</td>
                                                        <td>{res.me_employee}</td>
                                                        <td>{res.me_designation}</td>
                                                        <td>{res.me_address}</td>
                                                        <td>{res.me_country}</td>
                                                        <td>{res.me_state}</td>
                                                        <td>{res.me_city}</td>
                                                        <td>{res.me_mobile}</td>
                                                        <td>{res.me_pan}</td>
                                                        <td>{res.me_greyhr_code}</td>
                                                        <td>{res.me_email}</td>
                                                        <td>{res.me_status == 1 ? "ACTIVE" : "INACTIVE"}</td>
                                                    </tr>
                                                ))) : (

                                                    <tr>
                                                        <td colSpan="4" className="textCenter">Data not found</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </>
                }
            </Container>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            {/* <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div> */}
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
            </div>
        </>
    )
}

export default Master_executive;
